import ImageSection from "../../components/imageSection/ImageSection";
import Tabmenu from "../../components/tabmenu/Tabmenu";
import PartByPartSearch from "../../components/partByPartSearch/PartByPartSearch";
import ModelByModelSearch from "../../components/modelByModelSearch/ModelByModelSearch";
import Topbar from "../../components/topbar/Topbar";
import React, { useState, useEffect } from "react";
import Search from "../../components/search/Search";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import DocumentByModelSearch from "../../components/documentByModelSearch/DocumentByModelSearch";
import PartByModelSearch from "../../components/partByModelSearch/PartByModelSearch";
import Pricing from "../../components/pricing/Pricing";
import PricingResult from "../../components/pricingResult/PricingResult";
import "./home.css";

export default function Home() {
  const [selectedTab, setSelectedTab] = useState("SEARCH");
  const [partData, setPartData] = useState(null);
  const [modelData, setModelData] = useState(null);
  const [documentData, setDocumentData] = useState(null);
  const [partByModelData, setPartByModelData] = useState(null);
  const [pricingData, setPricingData] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [pricingResultData, setPricingResultData] = useState(null);
  const [isContentVisible, setIsContentVisible] = useState(false);

  // Animation effect for content visibility
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsContentVisible(true);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const renderTabContent = () => {
    switch (selectedTab) {
      case "SEARCH":
        return (
          <Search
            setSelectedTab={setSelectedTab}
            setPartData={setPartData}
            setModelData={setModelData}
            setDocumentData={setDocumentData}
            setPartByModelData={setPartByModelData}
            setImageData={setImageData}
          />
        );
      case "MODELS":
        return (
          <ModelByModelSearch
            data={modelData}
            documentData={documentData}
            partByModelData={partByModelData}
            imageData={imageData}
            setSelectedTab={setSelectedTab}
            setDocumentData={setDocumentData}
            setPartByModelData={setPartByModelData}
            setPartData={setPartData}
            setImageData={setImageData}
            setModelData={setModelData}
          />
        );
      case "DOCUMENTS":
        return (
          <DocumentByModelSearch
            data={documentData}
            setSelectedTab={setSelectedTab}
            setPartByModelData={setPartByModelData}
            setPartData={setPartData}
            setImageData={setImageData}
            setDocumentData={setDocumentData}
          />
        );
      case "PARTS":
        if (partData && partData.length !== 0) {
          return (
            <PartByPartSearch
              data={partData}
              setSelectedTab={setSelectedTab}
              setModelData={setModelData}
              setDocumentData={setDocumentData}
              setPricingData={setPricingData}
              setPartData={setPartData}
            />
          );
        } else if (partByModelData && partByModelData.length !== 0) {
          const modelNumber = partByModelData[0]?.model || "";
          // Get documentId from documentData first, then fallback to partByModelData
          const documentId = (documentData && documentData.length > 0 && documentData[0]?.documentId) 
            || (partByModelData[0]?.documentId) 
            || null;
          return (
            <PartByModelSearch
              data={partByModelData}
              setSelectedTab={setSelectedTab}
              setPricingData={setPricingData}
              setPartByModelData={setPartByModelData}
              setImageData={setImageData}
              modelNumber={modelNumber}
              documentId={documentId}
            />
          );
        } else {
          return (
            <PartByPartSearch
              data={null}
              setSelectedTab={setSelectedTab}
              setModelData={setModelData}
              setDocumentData={setDocumentData}
              setPricingData={setPricingData}
              setPartData={setPartData}
            />
          );
        }
      case "IMAGE":
        const imageModelNumber = imageData && imageData.length > 0 ? (imageData[0]?.model || "") : "";
        const imageDocumentId = (documentData && documentData.length > 0 && documentData[0]?.documentId) 
          || (imageData && imageData.length > 0 && imageData[0]?.documentId) 
          || null;
        return (
          <ImageSection
            data={imageData}
            setSelectedTab={setSelectedTab}
            setPricingData={setPricingData}
            setImageData={setImageData}
            modelNumber={imageModelNumber}
            documentId={imageDocumentId}
          />
        );
      case "PRICING":
        return (
          <Pricing
            data={pricingData}
            setSelectedTab={setSelectedTab}
            setPricingResultData={setPricingResultData}
          />
        );
      case "PRICING RESULT":
        return (
          <PricingResult
            data={pricingResultData}
            setSelectedTab={setSelectedTab}
            setPricingData={setPricingData}
          />
        );
      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className="mainPageContent">
      <Topbar />
      <Tabmenu
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
      />
      
      {/* Floating background elements */}
      <div className="floating-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
        <div className="floating-circle circle-4"></div>
        <div className="floating-square square-1"></div>
        <div className="floating-square square-2"></div>
        <div className="floating-square square-3"></div>
      </div>
      
      <div className={`contentWrapper ${isContentVisible ? 'content-visible' : ''}`}>
        {renderTabContent()}
      </div>
    </div>
  );
}
